import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-frame-3',
  templateUrl: './frame-3.component.html',
  styleUrls: ['./frame-3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFrame3Component {
  @Input() appPageTitle = '';
  @Input() appFavicon= '';
  @Input() type = '';
  @Input() logo= '';
  @Input() logoName= '';
  @Input() logoSlogan='';
  @Input() logoLink= '';
  @Input() logoSloganMobile='';
  @Input() copyRightInfo='';
  @Input() breadcrumb: {
    link: string,
    label: string
  }[] = [];

  @Input() links? : {
    fragment?: string;
    text: string;
    link?: string;
    special: boolean;
    textOver?: string;
  }[] = [];

  @Input() contacts?: {
    department: string;
    phone?: string;
    email?: string;
    address?: string;
  }[];

  @Input() content?: {
    fragment?: string;
    text: string;
    link?: string;
  }[];
}
